import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a1c1b770&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a1c1b770&prod&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c1b770",
  null
  
)

export default component.exports